module.exports = __webpack_public_path__ + "img/head-banner.144ea510.png";